import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentTab } from 'projects/admin/src/app/models/exemptionFilling';
import { forkJoin } from 'rxjs';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';

@Component({
  selector: 'app-external-payment',
  templateUrl: './external-payment.component.html',
  styleUrls: ['./external-payment.component.scss'],
})
export class ExternalPaymentComponent implements OnInit {
  requestId: any;
  data: any;
  fisPaymentData: any;
  fisPaymentTypeCode = 'FIS';
  paymentTypes: any;
  constructor(
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private routerService: Router,
    private router: ActivatedRoute,
    private commonService: ExternalCommonService
  ) {}

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.exemptionFilingRequestService
      .getExemptionFilingRequestDetail(this.requestId)
      .subscribe((res) => {
        this.data = res;
        console.log(this.data);
      });

    this.commonService.getPaymentTypes().subscribe((res) => {
      this.paymentTypes = res;
      this.exemptionFilingRequestService
        .getPayments(this.requestId)
        .subscribe((payments: PaymentTab[]) => {
          const fisPaymentId = this.paymentTypes.find(
            (x: { code: string }) => x.code == this.fisPaymentTypeCode
          )?.id;
          payments.sort((a, b) => (a?.id < b?.id ? 1 : -1));
          this.fisPaymentData = payments.find(
            (x) => x.paymentTypeId == fisPaymentId
          );
        });
    });

    forkJoin({
      exm: this.exemptionFilingRequestService
      .getExemptionFilingRequestDetail(this.requestId),
      reqT: this.commonService.getRequestStatusTypes(),
      externalT: this.commonService.getExternalStatusTypes(),
    }).subscribe(({exm, reqT, externalT }) => {
      this.data = exm;
      let reqType = reqT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      console.log(exm?.exemptionRequestType?.code);
      if (exm?.exemptionRequestType?.code == 'RECOPY') {
        reqType = reqT.find(
          (x: { code: string }) => x.code == 'ACCEPTED'
        )?.id;
      }
      const ereqType = externalT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      this.exemptionFilingRequestService
        .updateRequestStatus(this.requestId, ereqType, reqType)
        .subscribe((res) => {
          console.log(res);
        });
    });
  }

  onClose() {
    window.location.href =
      'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
  }
}
